/*
 * SPDX-FileCopyrightText: 2022 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { NgModule } from '@angular/core';
import { ADD_TO_CART_FEATURE, CART_BASE_FEATURE, CartBaseRootModule, MINI_CART_FEATURE } from '@spartacus/cart/base/root';
import { provideConfig } from '@spartacus/core';
import { en } from '../../../../../public/translations/en';
import { es } from '../../../../../public/translations/es';

@NgModule({
  imports: [CartBaseRootModule],
  providers: [
    provideConfig({
      featureModules: {
        [CART_BASE_FEATURE]: {
          module: () => import('./cart-base.module').then((m) => m.CartBaseModule),
        },
      },
    }),
    provideConfig({
      featureModules: {
        [MINI_CART_FEATURE]: {
          module: () => import('../../custom/cms-components/cart/custom-mini-cart/custom-mini-cart.module').then((m) => m.CustomMiniCartModule),
        },
      },
    }),
    provideConfig({
      featureModules: {
        [ADD_TO_CART_FEATURE]: {
          module: () => import('../../custom/cms-components/cart/custom-add-to-cart/custom-add-to-cart.module').then((m) => m.CustomAddToCartModule),
        },
      },
    }),
    provideConfig({
      i18n: {
        resources: { en: { cart: en.cart }, es: { cart: es.cart } }
      }
    })
  ]
})
export class CartBaseFeatureModule {}
